import { FormComponent, FormComponentProps } from '../index';
import Show from './show';
import HtmlBlock from './html-block';
import React, { useEffect } from 'react';
import { useObservableState } from 'observable-hooks';
import { debounceTime, filter, switchMap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { useWatch } from 'react-hook-form';
import FormField from '../../common/form-field';

export default function Warning(
  message: string,
  showOn?: string | string[],
  callback?: (watchValues: any) => boolean | Promise<boolean>
): FormComponent {
  if (showOn) {
    return Show(HtmlBlock('', message), showOn, callback);
  } else {
    return HtmlBlock('', message);
  }
}

export function DebouncedWarning(
  message: string,
  showOn: string | string[],
  observableCallback: (showOnValues: any) => Observable<boolean>,
  debounceTime: number = 1000,
  initial: boolean = false
) {
  return ({ ...rest }) => (
    <DebouncedWarningComponent
      {...rest}
      message={message}
      showOn={showOn}
      observableCallback={observableCallback}
      debounce={debounceTime}
      initial={initial}
    />
  );
}

export function DebouncedWarningComponent({
  message,
  showOn,
  observableCallback,
  debounce,
  initial,
  readonly,
  parentName,
}: {
  message: string;
  showOn: string | string[];
  observableCallback: (showOnValues: any) => Observable<boolean>;
  debounce: number;
  initial: boolean;
} & FormComponentProps) {
  const [show, setShow] = useObservableState<boolean, any[]>(
    (source) =>
      source.pipe(
        debounceTime<any[]>(debounce),
        filter((value: any[]) => !!value.filter(Boolean).length),
        switchMap((values: any[]) => observableCallback(values))
      ),
    initial
  );

  if (parentName) {
    showOn = [showOn].flat().map((name) => {
      switch (true) {
        case name.startsWith('/'):
          return name.substring(1);
        case name.startsWith('_'):
          return name.substring(1).replace(/__(\d+)__/g, (match, index) => {
            return '.' + parentName.split('.')[index] + '.';
          });
        default:
          return `${parentName}.${name}`;
      }
    });
  }

  const showOnValues = useWatch({
    name: Array.isArray(showOn) ? showOn : [showOn],
  });
  useEffect(() => setShow(showOnValues), [setShow, showOnValues]);

  return !readonly && show ? (
    <FormField label={''} labelFor={null} className="text-error">
      {message}
    </FormField>
  ) : null;
}
